/*import React from 'react';
import { NavLink } from 'react-router-dom';
import './footer.css'; // Yeni css dosyasını import et

const CustomFooter = () => {
    return (
        <footer className="custom-footer bg-light">
            <div className="container">
                <ul className="footer-nav">
                    <li className="footer-nav-item">
                        <NavLink className="footer-nav-link" to="/hakkinda">Reeder Hakkında</NavLink>
                    </li>
                    <li className="footer-nav-item">
                        <NavLink className="footer-nav-link" to="/kesfet">Reeder'ı Keşfet</NavLink>
                    </li>
                    <li className="footer-nav-item">
                        <NavLink className="footer-nav-link" to="/reederliningozunden">Reederlının Gözünden</NavLink>
                       </li>
                    <li className="footer-nav-item">
                        <NavLink className="footer-nav-link" to="/form">İş Başvurusu</NavLink>
                    </li>
                    <li className="footer-nav-item">
                        <NavLink className="footer-nav-link" to="/ikuygulamalari">İK Uygulamaları</NavLink>
                    </li>
                    <li className="footer-nav-item">
                        <NavLink className="footer-nav-link" to="/egitimler">Eğitimler</NavLink>
                    </li>
                    <li className="footer-nav-item">
                        <NavLink className="footer-nav-link" to="/giris">Giriş Yap</NavLink>
                    </li>
                </ul>
                <div className="footer-info">
                    <div className="footer-info-section">
                        <h5>İletişim</h5>
                        <ul className="footer-info-list">
                            <li>E-posta: ik@reeder-op.com</li>
                        </ul>
                    </div>
                    <div className="footer-info-section">
                        <h5>Bizi Takip Edin</h5>
                        <ul className="footer-info-list">
                            <li><a href="https://www.instagram.com/reeder.tr/" className="footer-link">Instagram</a></li>
                            <li><a href="https://www.facebook.com/reedertr" className="footer-link">Facebook</a></li>
                            <li><a href="https://www.linkedin.com/company/reeder/" className="footer-link">LinkedIn</a></li>
                            <li><a href="https://www.youtube.com/channel/UCVD5ZRF-201v-v7xBoALZ5Q" className="footer-link">YouTube</a></li>
                            <li><a href="https://x.com/reederebr?lang=en" className="footer-link">X</a></li>
                        </ul>

                    </div>
                </div>
                <div className="footer-copyright text-center mt-3">
                    <p>&copy; 2024 Copyright @ Tüm haklar Reeder'a aittir...</p>
                </div>
            </div>
        </footer>
    );
}

export default CustomFooter;*/

/*
import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInstagram,
  faFacebook,
  faLinkedin,
  faYoutube,
  faXTwitter
} from '@fortawesome/free-brands-svg-icons'; // Import social media icons
import './footer.css';

const CustomFooter = () => {
    return (
        <footer className="custom-footer bg-light">
            <div className="container">
                <ul className="footer-nav">
                    <li className="footer-nav-item">
                        <NavLink className="footer-nav-link" to="/hakkinda">Reeder Hakkında</NavLink>
                    </li>
                    <li className="footer-nav-item">
                        <NavLink className="footer-nav-link" to="/kesfet">Reeder'ı Keşfet</NavLink>
                    </li>
                    <li className="footer-nav-item">
                        <NavLink className="footer-nav-link" to="/reederliningozunden">Reederlının Gözünden</NavLink>
                    </li>
                    <li className="footer-nav-item">
                        <NavLink className="footer-nav-link" to="/form">İş Başvurusu</NavLink>
                    </li>
                    <li className="footer-nav-item">
                        <NavLink className="footer-nav-link" to="/ilanlar">İş İlanları</NavLink>
                    </li>
                    <li className="footer-nav-item">
                        <NavLink className="footer-nav-link" to="/ikuygulamalari">İK Uygulamaları</NavLink>
                    </li>
                    <li className="footer-nav-item">
                        <NavLink className="footer-nav-link" to="/egitimler">Eğitimler</NavLink>
                    </li>
                    <li className="footer-nav-item">
                        <NavLink className="footer-nav-link" to="/giris">Giriş Yap</NavLink>
                    </li>
                    <li className="footer-nav-item">
                        <NavLink className="footer-nav-link" to="/kayit">Kayıt Ol</NavLink>
                    </li>
                </ul>
                <div className="footer-info">
                    <div className="footer-info-section">
                        <h5>İletişim</h5>
                        <ul className="footer-info-list">
                            <li><a href="mailto:insankaynaklari@reeder-op.com" className="footer-email"> insankaynaklari@reeder-op.com</a></li>
                        </ul>
                    </div>
                    <div className="footer-info-section">
                        <h5>Bizi Takip Edin</h5>
                        <ul className="footer-social-list">
                            <li>
                                <a href="https://www.instagram.com/reeder.tr/" className="footer-link">
                                    <FontAwesomeIcon icon={faInstagram} />
                                </a>
                            </li>
                            <li>
                                <a href="https://www.facebook.com/reedertr" className="footer-link">
                                    <FontAwesomeIcon icon={faFacebook} />
                                </a>
                            </li>
                            <li>
                                <a href="https://www.linkedin.com/company/reeder/" className="footer-link">
                                    <FontAwesomeIcon icon={faLinkedin} />
                                </a>
                            </li>
                            <li>
                                <a href="https://www.youtube.com/channel/UCVD5ZRF-201v-v7xBoALZ5Q" className="footer-link">
                                    <FontAwesomeIcon icon={faYoutube} />
                                </a>
                            </li>
                            <li>
                                <a href="https://x.com/reederebr?lang=en" className="footer-link">
                                    <FontAwesomeIcon icon={faXTwitter} />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="footer-copyright text-center mt-3">
                    <p>&copy; 2024 Copyright @ Tüm haklar Reeder'a aittir...</p>
                </div>
            </div>
        </footer>
    );
}

export default CustomFooter;
*/


import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from '../images/REEDER_LOGO.svg';
import {
  faInstagram,
  faFacebook,
  faLinkedin,
  faYoutube,
  faGithub,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import "./footer.css";

const CustomFooter = () => {
  return (
        <footer className="reeder-footer">
          <div className="footer-content">
            {/* Logo */}
            <div className="footer-logo">
              <img
                src={logo}
                alt="Reeder Logo"
              />
            </div>
    
            {/* Başlıklar */}
            <div className="footer-links">
              <ul className="footer-links-list">
                <li>
                  <a href="/hakkinda">Reeder Hakkında</a>
                </li>
                <li>
                  <a href="/kesfet">Reeder’i Keşfet</a>
                </li>
                <li>
                  <a href="/reederliningozunden">Reederlının Gözünden</a>
                </li>
                <li>
                  <a href="/ilanlar">İş İlanları</a>
                </li>
                <li>
                  <a href="/form">İş Başvurusu</a>
                </li>
              </ul>
              <ul className="footer-links-list">
                <li>
                  <a href="/stajbasvuru">Staj Başvurusu</a>
                </li>
                <li>
                  <a href="/ikuygulamalari">İK Uygulamaları</a>
                </li>
                <li>
                  <a href="/egitimler">Eğitimler</a>
                </li>
                <li>
                  <a href="/kayit">Kayıt Ol</a>
                </li>
                <li>
                  <a href="/giris">Giriş Yap</a>
                </li>
              </ul>
            </div>
    
            {/* Alt Kısım */}
            <div className="footer-bottom">
  <div className="footer-info">
    <h3>
      © Reeder Teknoloji A.Ş.
      <span className="separator">|</span>
      <a href="/kullanim-kosullari">Kullanım Koşulları</a>
      <span className="separator">|</span>
      <a href="/gizlilik-politikasi">Gizlilik Politikası</a>
      <span className="separator">|</span>
      <a href="/guvenlik">Güvenlik</a>
    </h3>
  </div>
  <div className="footer-icons">
    <a href="https://www.instagram.com/reeder.tr/">
      <FontAwesomeIcon icon={faInstagram} />
    </a>
    <a href="https://www.facebook.com/reedertr">
      <FontAwesomeIcon icon={faFacebook} />
    </a>
    <a href="https://www.linkedin.com/company/reeder/">
      <FontAwesomeIcon icon={faLinkedin} />
    </a>
    <a href="https://x.com/reederebr?lang=en">
      <FontAwesomeIcon icon={faXTwitter} />
    </a>
    <a href="https://www.youtube.com/channel/UCVD5ZRF-201v-v7xBoALZ5Q">
      <FontAwesomeIcon icon={faYoutube} />
    </a>
    <a href="https://github.com/reeder-tech">
      <FontAwesomeIcon icon={faGithub} />
    </a>
  </div>
</div>
          </div>
        </footer>
      );
    };

export default CustomFooter;
